import { render, staticRenderFns } from "./PendingRow.vue?vue&type=template&id=12072ac6"
import script from "./PendingRow.vue?vue&type=script&lang=js"
export * from "./PendingRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports